<template>
  <div class="json-wrap">
    <div class="json-row" v-for="(schemaItem, key) in schema" :key="key">
      <template v-if="schemaItem.type === global.formType">
        <v-container class="pt-0 pb-0">
          <v-card-text class="pa-0">
            <v-card-title class="subtitle-1 pr-0 pl-0 pb-0">{{
              schemaItem.name
            }}</v-card-title>
            <v-select
              :items="formList"
              item-text="item"
              item-value="key"
              v-model="json[key]"
              filled
            >
            </v-select>
          </v-card-text>
        </v-container>
      </template>
      <template v-else-if="!isInner || key !== 'title'">
        <Field
          :schema-item="schemaItem"
          :item-key="key"
          :json-item="json"
          :item-title="schemaItem.name"
          :landing-id="landingId"
        />
      </template>
      <v-container v-if="schemaItem.type === global.metaType">
        <v-card>
          <v-btn
            class="mx-2"
            fab
            dark
            color="indigo"
            @click="createItem(schemaItem, key)"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
          <v-list v-if="json[key] && json[key].length">
            <v-list-item v-for="(item, index) in json[key]" :key="index">
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
              <v-btn
                class="mr-2"
                color="primary"
                @click="editItem(schemaItem, item, index, key)"
                dark
              >
                <v-icon center>mdi-pencil</v-icon>
              </v-btn>
              <v-btn color="red" @click="deleteItem(index, key)" dark>
                <v-icon center>mdi-delete</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-card>
      </v-container>
    </div>
    <v-dialog v-model="dialog" max-width="720px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedSchema.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <div class="json-row">
              <v-card-title class="subtitle-1">Заголовок :</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="editedItem['title']"
                  :rules="[global.rules.required]"
                >
                </v-text-field>
              </v-card-text>
            </div>
            <ManagementFields
              :landing-id="landingId"
              :json="editedItem"
              :schema="editedSchema.values"
              :is-inner="true"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Отмена</v-btn>
          <v-btn color="blue darken-1" text @click="save">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Field from "@/components/Field";
import { GLOBAL } from "@/config/consts";

export default {
  name: "ManagementFields",
  components: { Field },
  props: {
    schema: {
      type: Object,
      required: true
    },
    json: {
      type: Object,
      required: true
    },
    forms: {
      type: Array,
      required: false
    },
    landingId: {
      type: String,
      required: true
    },
    isInner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      editedItem: {},
      editedSchema: {},
      editedKey: "",
      global: GLOBAL
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formList() {
      const list = [
        {
          key: null,
          item: ""
        }
      ];
      this.forms.map(form => {
        list.push({
          key: form.id,
          item: `(${form.id}) ${form.name}`
        });
      });
      return list;
    }
  },
  methods: {
    createItem(schemaItem, key) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
        this.$refs.form.reset();
      }
      this.dialog = true;
      this.editedKey = key;
      this.editedSchema = Object.assign({}, schemaItem);
    },
    editItem(schemaItem, item, index, key) {
      this.editedIndex = index;
      this.editedKey = key;
      this.editedItem = Object.assign({}, item);
      this.editedSchema = Object.assign({}, schemaItem);
      this.dialog = true;
    },
    deleteItem(index, key) {
      if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
        this.json[key].splice(index, 1);
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = {};
        this.schemaItem = {};
        this.editedIndex = -1;
        this.editedKey = "";
        this.$refs.form.resetValidation();
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.editedIndex > -1) {
        Object.assign(
          this.json[this.editedKey][this.editedIndex],
          this.editedItem
        );
      } else {
        if (!this.json[this.editedKey]) {
          this.$set(this.json, this.editedKey, []);
        }
        this.json[this.editedKey].push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
